/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Compliance_BadgeInputs */

const en_onboarding_compliance_badge = /** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required for Compliance`)
};

const es_onboarding_compliance_badge = /** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requerido para el Cumplimiento`)
};

const fr_onboarding_compliance_badge = /** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requis pour la conformité`)
};

const de_onboarding_compliance_badge = /** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderlich für Compliance`)
};

const id_onboarding_compliance_badge = /** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diwajibkan untuk Kepatuhan`)
};

/** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */
const ja_onboarding_compliance_badge = en_onboarding_compliance_badge;

/** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */
const zh_onboarding_compliance_badge = en_onboarding_compliance_badge;

/** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */
const ar_onboarding_compliance_badge = en_onboarding_compliance_badge;

/** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */
const it_onboarding_compliance_badge = en_onboarding_compliance_badge;

/** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */
const ru_onboarding_compliance_badge = en_onboarding_compliance_badge;

/** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */
const pt_onboarding_compliance_badge = en_onboarding_compliance_badge;

/** @type {(inputs: Onboarding_Compliance_BadgeInputs) => LocalizedString} */
const ko_onboarding_compliance_badge = en_onboarding_compliance_badge;

/**
* | output |
* | --- |
* | "Required for Compliance" |
*
* @param {Onboarding_Compliance_BadgeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const onboarding_compliance_badge = /** @type {((inputs?: Onboarding_Compliance_BadgeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Compliance_BadgeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_compliance_badge(inputs)
	if (locale === "es") return es_onboarding_compliance_badge(inputs)
	if (locale === "fr") return fr_onboarding_compliance_badge(inputs)
	if (locale === "de") return de_onboarding_compliance_badge(inputs)
	if (locale === "ja") return ja_onboarding_compliance_badge(inputs)
	if (locale === "zh") return zh_onboarding_compliance_badge(inputs)
	if (locale === "ar") return ar_onboarding_compliance_badge(inputs)
	if (locale === "id") return id_onboarding_compliance_badge(inputs)
	if (locale === "it") return it_onboarding_compliance_badge(inputs)
	if (locale === "ru") return ru_onboarding_compliance_badge(inputs)
	if (locale === "pt") return pt_onboarding_compliance_badge(inputs)
	return ko_onboarding_compliance_badge(inputs)
});